import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorageService } from 'angular-2-local-storage';
import {HttpParams} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {debounceTime, distinctUntilChanged, catchError, tap, switchMap, map} from 'rxjs/Operators';
import {NgbTypeaheadSelectItemEvent} from '@ng-bootstrap/ng-bootstrap';
import { Address } from 'ngx-google-places-autocomplete/objects/address';

import * as _ from 'lodash';

import { Experience } from '../../interfaces/interfaces';
import { ResumeService } from '../../services/resume.service';
import { AuthService } from '../../../core/services/auth.service';
import { UtilService } from '../../../shared/services/util.service';

@Component({
  selector: 'app-add-experience',
  templateUrl: './add-experience.component.html',
  styleUrls: ['./add-experience.component.css']
})
export class AddExperienceComponent {
  public options = {type : 'address', componentRestrictions: {}};
  public experiences = [] as Array<Experience>;
  public newExp = {
    start_month: null,
    start_year: null,
    end_month: null,
    end_year: null,
    current_employer: 0
  } as Experience;
  public addMore = true;
  public descs = [];
  public temp_title: any;
  public searching = false;
  public hideSearchingWhenUnsubscribed = new Observable(() => () => this.searching = false);
  public loading = false;
  public level = 'experience';
  public months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  public rec_titles = [];
  public theme_id;
  public searchFailed = false;
  constructor(
    private authService: AuthService,
    private router: Router,
    private resumeService: ResumeService,
    private localStorageService: LocalStorageService,
    public utilService: UtilService
  ) {
    if (this.authService.session.isActive) {
      this.authService.getUserByToken(this.authService.token.token).subscribe(profile => {
        this.authService.session.profile = profile;
      });
    }
    const resume_id = this.localStorageService.get('resume_id');
    const anon = this.localStorageService.get('anon');
    // this.level = anon.level;
    if (resume_id) {
      this.newExp.resume_id = resume_id.toString();
      this.resumeService.getResumeById(resume_id).subscribe(res => {
        this.experiences = res.Experience || [];
        this.experiences = _.sortBy(this.experiences, ['index']);
        if (this.experiences.length > 0) {
          this.addMore = false;
        }
        this.level = res.Resume.level;
      });
    }
    let p = new HttpParams();
    p = p.set('q', 'General');
    this.utilService.getExpText(p).subscribe(res => {
      this.descs = res || [];
    });
    this.theme_id = this.localStorageService.get('theme_id') as string || 1;
  }
  handleAddressChange(address: Address, model: Experience) {
    model.employer = address.name;
    model.employer_address = address.vicinity;
  }
  add() {
    const resume_id = this.localStorageService.get('resume_id') as string;
    this.newExp.resume_id = resume_id;
    this.newExp.job_title = this.temp_title.title || this.temp_title;
    this.resumeService.updateExperience(this.newExp).subscribe(res => {
      this.experiences.unshift(res.experience);
      this.router.navigate(['/resume/skill']);
    }, err => {
      console.log(err);
    });
  }
  onEditClick(exp) {
    exp.edit = true;
    this.temp_title = exp.job_title;
    let p = new HttpParams();
    p = p.set('q', exp.job_title);
    this.utilService.getExpText(p).subscribe(res => {
      this.descs = res || [];
      if (res === null) {
        this.temp_title = exp.job_title;
        let q = new HttpParams();
        q = q.set('q', 'General');
        this.utilService.getExpText(q).subscribe(res1 => {
          this.descs = res1 || [];
        })
      }
    });
  }
  edit(exp) {
    exp.job_title = this.temp_title.title || this.temp_title;
    this.resumeService.updateExperience(exp).subscribe(res => {
      const theme_id = this.localStorageService.get('theme_id') as string || 1;
      this.router.navigate(['/themes/' + theme_id]);
      exp.edit = false;
      exp = res;
    });
  }
  remove(exp) {
    exp.delete = 1;
    this.resumeService.updateExperience(exp).subscribe(res => {
      const index = this.experiences.lastIndexOf(exp);
      this.experiences.splice(index, 1);
    });
  }
  next() {
    this.router.navigate(['/resume/skill']);
  }
  appendDescription(model, desc) {
    if (!model.description) {
      model.description = '';
    }
    const ul_end_at = model.description.lastIndexOf('</ul>');
    if (ul_end_at === -1) {
      model.description += ('<ul><li>' + desc.text + '</li></ul>');
    } else {
      model.description = model.description.substring(0, ul_end_at)
        + '<li>' + desc.text + '</li>' +
        model.description.substring(ul_end_at, model.description.length);
    }
  }
  googleSearch(evt, place) {
    const _self = this;
    setTimeout(() => {
      _self.utilService.getGooglePlaces(place).then(res => {})
    }, 3000);
  }

  pull_data_rec_title(term: string): Observable<any[]> {
    let p = new HttpParams();
    p = p.set('level', 'experience');
    p = p.set('title', term);
    return this.utilService.getRecommendedTitle(p).pipe(map(res => {
      const arr = Object.keys(res).map((key) => res[key]).sort((a, b) => (b.score - a.score));
      this.rec_titles = arr;
      return <any[]> arr;
    }));
  }
  formatter_rec_title(result: any): string {
    return result.title || result;
  }
  search_rec_title = (text$: Observable<string>) =>
  text$.pipe(
    debounceTime(300),
    distinctUntilChanged(),
    tap(() => this.searching = true),
    switchMap(term =>
      this.pull_data_rec_title(term).pipe(
        tap(() => this.searchFailed = false),
        catchError(() => {
          this.searchFailed = true;
          return of([]);
        }))
    ),
    tap(() => this.searching = false)
  )
  
  onSelect(selectedItem: NgbTypeaheadSelectItemEvent, model) {
    model.job_title = selectedItem.item.title;
    let p = new HttpParams();
    p = p.set('q', selectedItem.item.title);
    this.utilService.getExpText(p).subscribe(res => {
      this.descs = res || [];
    });
  }
  searchIfNotMatch(title) {
    if (!title.title) {
      if (this.rec_titles.length > 0) {
        if (this.rec_titles[0].score > 70) {
          let p = new HttpParams();
          p = p.set('q', this.rec_titles[0].title);
          this.utilService.getExpText(p).subscribe(res => {
            this.descs = res || [];
          });
        } else {
          let p = new HttpParams();
          p = p.set('q', 'General');
          this.utilService.getExpText(p).subscribe(res => {
            this.descs = res || [];
          });
        }
      }
    }
  }
  goToTheme () {
    const theme_id = this.localStorageService.get('theme_id') as string || 1;
    this.router.navigate(['/themes/' + theme_id]);
  }
  /*// not using these maybe used later.
  pull_data_rec_text(term: string): Observable<any[]> {
    let p = new HttpParams();
    p = p.set('level', 'experience');
    p = p.set('title', term);
    return this.utilService.getExpText(p).map(res => {
      const arr = Object.keys(res).map((key) => res[key]).sort((a, b) => (b.score - a.score));
      return <any[]> arr;
    });
  }
  formatter_rec_text(result: any): string {
    return result.title || result;
  }
  search_rec_text = (text$: Observable<string>) =>
    text$
      .debounceTime(200)
      .distinctUntilChanged()
      .switchMap(term => term.length < 5 ? []
        : this.pull_data_rec_text(term)
          .do(() => noop()/!*this.searchFailed = false*!/)
          .catch(() => {
            /!*this.searchFailed = true;*!/
            return Observable.of([]);
          }))
      .do(() => noop()/!*this.searching = false*!/)
      .merge(this.hideSearchingWhenUnsubscribed);*/
  // moveUp(model, index) {
  //   console.log(model, index);
  // }
  // moveDown(model, index) {
  //   if (index < this.experiences.length - 1) {
  //     // abc
  //   }
  //   const next =
  //   model.index = index + 1;
  // }
  swapIndex(model1, model2) {
    const temp = JSON.parse(JSON.stringify(model2.index));
    model2.index = JSON.parse(JSON.stringify(model1.index));
    model1.index = temp;
    this.resumeService.updateExperience(model1).subscribe(res1 => {
      this.resumeService.updateExperience(model2).subscribe(res2 => {
        const resume_id = this.localStorageService.get('resume_id');
        this.resumeService.getResumeById(resume_id).subscribe(res => {
          this.experiences = res.Experience || [];
          this.experiences = _.sortBy(this.experiences, ['index']);
          if (this.experiences.length > 0) {
            this.addMore = false;
          }
          this.level = res.Resume.level;
        });
      });
    });
  }
}
